import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Planzone, Project, Zone } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  zones: (Identifiable<Zone> & {
    projects: Identifiable<Project>[];
  })[];
  retrieveZones(request: Boundaries["retrieveZones"]["request"]): void;
}

function useZonesRetrieval(planzone: Identifiable<Planzone>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isZonesRetrievalRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isZonesRetrievalRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isZonesRetrievalRequestFailure(planzone),
    ),
    zones: useSelector(() => selector.getZones(planzone)),
    retrieveZones: core.retrieveZones,
  };
}

export { useZonesRetrieval };
